export default class UIAccessController {
  isDebug = false

  me
  uiConfig
  policyStatements

  constructor(me, uiConfig, userPolicies) {
    this.me = me
    this.uiConfig = uiConfig

    let statements = this.#extractStatements(userPolicies)
    this.policyStatements = this.#mergeStatements(statements)
  }

  // extractStatements(userPolicies) : statements[]
  // extract statements list from all user's policies
  #extractStatements(userPolicies) {
    let result = []

    // check userPolicies is undefined
    if (!userPolicies.policies) {
      this.#log('policies is undefined')
      return result
    }

    userPolicies.policies.forEach(data => {
      result = result.concat(data.policy.Statements)
    })

    return result
  }

  // mergeStatements(statement[]) : statement[]
  // merge and de-duplicate actions by resource
  #mergeStatements(policyStatements) {
    // merge and de-duplicate actions by resource
    let temp = {}
    policyStatements.forEach(policyStatement => {
      let resource = policyStatement.Resource
      let actions = policyStatement.Actions

      if (!temp[resource]) {
        temp[resource] = []
      }

      temp[resource] = temp[resource].concat(actions)
    })

    let result = []
    for (let resource in temp) {
      let actions = temp[resource]
      result.push({
        Effect: 'Allow',
        Resource: resource,
        Actions: actions,
        Conditions: {}
      })
    }

    return result
  }

  // check uiCode is enable
  isEnable(uiCode) {
    this.#log(`isEnable(uiCode: "${uiCode}")`)

    const MODE_ENABLE = 'enable'
    const MODE_DISABLE = 'disable'
    const MODE_POLICY = 'policy'

    // get ui & check ui is existed
    let uiConfigList = this.uiConfig.ui_config
    let ui = uiConfigList[uiCode]
    if (!ui) {
      this.#log(`uiCode: "${uiCode}" is not existed`)
      return false
    }

    // get mode & check mode is existed
    let mode = ui.mode
    if (!mode) {
      this.#log(`mode of uiCode: "${uiCode}" is not existed`)
      return false
    }

    this.#log(`mode of uiCode: "${uiCode}" is "${mode}"`)

    switch (mode) {
      case MODE_ENABLE:
        return true
        break

      case MODE_DISABLE:
        return false
        break

      case MODE_POLICY:
        let uiPermissions = ui.permissions
        if (!uiPermissions) {
          this.#log(`permissions of uiCode: "${uiCode}" is not existed`)
          return false
        }
        return this.#validateUIPermissions(uiPermissions)
        break

      default:
        return false
    } // end switch

    return false
  }

  // check uiPermissions is match at least one policy statement
  // if match at least one statement, return true
  // if not match any policy, return false
  #validateUIPermissions(uiPermissions) {
    this.#log('ui require permissions:')
    this.#log(uiPermissions)

    // if permissions is undefined or empty, always enable
    // because if no permissions, it means no policy required
    if (!uiPermissions) {
      this.#log('permissions is undefined, always enable')
      return true
    }
    if (uiPermissions.length == 0) {
      this.#log('permissions is empty, always enable')
      return true
    }

    // default result is false
    // because if match at least one statement, return true
    // if not match any statement, return false
    // we use 'OR' to check with each policy
    let result = false

    uiPermissions.forEach(uiPermission => {
      let uiResource = uiPermission.resource
      let uiActions = uiPermission.actions

      result = result || this.#isMatchPolicyStatement(uiResource, uiActions)
    })

    return result
  }

  // check uiResource & uiActions is match with policy statement
  // if matched at least one resource & [all uiAction], return true
  // if not match, return false
  // - all uiActions must match with policy statement
  #isMatchPolicyStatement(uiResource, uiActions) {
    this.#log(`uiResource: "${uiResource}"`)
    this.#log(`uiActions:`)
    this.#log(uiActions)

    // default result is false
    // because if match at least one statement, return true
    let result = false

    this.policyStatements.forEach(policyStatement => {
      let policyResource = policyStatement.Resource
      let policyActions = policyStatement.Actions

      // check resource
      if (uiResource != policyResource) {
        this.#log(
          `uiResource: "${uiResource}" is not match with policyResource: "${policyResource}"`
        )
        return
      }

      // check actions
      result = result || this.#isIntersect(uiActions, policyActions)
    })

    return result
  }

  #isSubset(subset, superset) {
    return subset.every(value => superset.includes(value))
  }

  #isIntersect(smallerSet, biggerSet) {
    if (smallerSet.length === 0) {
      return true
    }

    return smallerSet.some(value => biggerSet.includes(value))
  }

  #log(message) {
    if (this.isDebug) {
      console.log(message)
    }
  }
}
